module.exports = "/v2/pages/dashboard/dist/cbe29823fdb53f1aca0b966fe6bab9fd.svg";